const validRoles = [
  { id: 'GML_SQUAD', name: 'Gml Squad', powerMiles: 100 },
  { id: 'ACTIVE', name: 'Active', powerMiles: 100 },
  { id: 'FIRST_CLASS', name: 'First Class', powerMiles: 100 },
  { id: 'PREMIUM_CLASS', name: 'Premium Class', powerMiles: 100 },
]

export { validRoles }